import { Piece, PlayerColor, PieceType } from '../../../../../shared/types/game';

// 駒オブジェクトを生成するヘルパー関数
export const createPiece = (type: PieceType, owner: PlayerColor, isPromoted: boolean = false): Piece => ({
  type,
  owner,
  isPromoted,
});

// 成り駒の種類を、成る前の元の駒の種類に変換するヘルパー関数
export const getOriginalPieceType = (pieceType: PieceType, isPromoted: boolean): PieceType => {
  if (isPromoted) {
    switch (pieceType) {
      case 'ryu': return 'hisha';
      case 'uma': return 'kaku';
      case 'tokin': return 'fu';
      case 'narigin': return 'gin';
      case 'narikei': return 'kei';
      case 'narikyo': return 'kyo';
      default: return pieceType;
    }
  }
  return pieceType;
};

// 成れる駒の種類を、成った後の駒の種類に変換するヘルパー関数
export const getPromotedPieceType = (pieceType: PieceType): PieceType => {
  switch (pieceType) {
    case 'fu': return 'tokin';
    case 'kyo': return 'narikyo';
    case 'kei': return 'narikei';
    case 'gin': return 'narigin';
    case 'hisha': return 'ryu';
    case 'kaku': return 'uma';
    default: return pieceType;
  }
};
